import { render, staticRenderFns } from "./NotificationDetailDoc.vue?vue&type=template&id=fe72e834"
import script from "./NotificationDetailDoc.vue?vue&type=script&lang=js"
export * from "./NotificationDetailDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailDoc.vue?vue&type=style&index=0&id=fe72e834&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports